export const Paths = {
    home: "/",
    about: "/about",
    contact: "/contact",
    products: "/products",
    terms: "/tos",
    brand: "/brand-resources",
    feedback: "/feedback",
    burrbs: "https://burrbs.com",
    ejukate: "https://welcome.ejukate.com",
    bootcamp: "https://bootcamp.intelligencepool.com",
    adeyhia: "https://adeyhia.com",
}